<template>
        <vx-card>

  <div>
    <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
  </div>
  </vx-card>
</template>
<script>

export default {
  data() {
    return {
      editorData: '<p>Content of the editor.</p>',
        editorConfig: {
            // The configuration of the editor.
        },
    };
  },
  methods: {
  }
};
</script>